<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>登記表</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>登記表</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <ul class="nav nav-tabs" role="tablist" v-if="isAdmin('tenancy')">ㄔ
              <li class="active">
                <router-link :to="'/tenancy-register'">登記表清單</router-link>
              </li>
              <li v-if="isAdmin('tenancy')">
                <router-link :to="'/tenancy-register/treaty'">設定隱私權宣告、管理辦法</router-link>
              </li>
            </ul>
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                學年度：
                <select v-model="search.schYearTerm">
                  <option v-for="item in schYearTermList" :key="item" :value="item.replace('/', '')">{{item}}</option>
                </select>
                <span v-if="loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM'">　系所：</span>
                <select v-if="loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM'" v-model="search.deptCode">
                  <option :value="null">請選擇</option>
                  <option v-for="(item, index) in deptList" :key="index" :value="item.code">{{item.value}}</option>
                </select>
                <span v-if="loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM'">　班級：</span>
                <select v-if="loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM'" v-model="search.dradeClass">
                  <option :value="null">請選擇</option>
                  <option v-for="(item, index) in dradeClassList" :key="index" :value="item.value">{{item.text}}</option>
                </select>
                <span v-if="(loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM')||isTenancy">　住宿方式：</span>
                <select v-if="(loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM')||isTenancy" v-model="search.stayType">
                  <option :value="null">--請選擇--</option>
                  <option value="與家人同住自宅">與家人同住自宅</option>
                  <option value="與家人一同租屋">與家人一同租屋</option>
                  <option value="寄宿親戚家">寄宿親戚家</option>
                  <option value="寄宿教會">寄宿教會</option>
                  <option value="寄宿朋友家">寄宿朋友家</option>
                  <option value="校外租屋">校外租屋</option>
                  <option value="學校宿舍">學校宿舍</option>
                  <option value="其他">其他</option>
                  <option value="未填寫">未填寫</option>
                </select>
                <span v-if="(loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM')||isTenancy">　學生姓名或學號：</span>
                <input type="text" v-if="(loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM')||isTenancy" v-model="search.keyword" />
              </div>
              <div align="center" style="padding:7px;">
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="s_dil" v-if="pageAdmin">
                設定開放時間：
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="opening.startDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" /> -
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="opening.endDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" />　
                <a href="#" @click.prevent="setOpeningDate" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">送出</a>
              </div>
              <div class="s_dir" v-if="(loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM')||isTenancy">
                <a href="#" @click.prevent="download" class="btn-upload btn btn-primary">清單匯出</a>
              </div>
              <div style=" clear:both;">
                <div style="text-align: right; margin-bottom: -10px;">
                  <img src="/assets/images/star.png"> 代表學生尚未填寫喔！
                </div>
                <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 8%">學年度</th>
                      <th class="text-center" style="width: 14%">系別班級</th>
                      <th class="text-center" style="width: 9%">學號</th>
                      <th class="text-center" style="width: 9%">姓名</th>
                      <th class="text-center" style="width: 10%">聯絡電話</th>
                      <th class="text-center" style="width: 10%">戶籍(縣市)</th>
                      <th class="text-center" style="width: 10%">校外賃居</th>
                      <th class="text-center" style="width: 30%">校外賃居地址</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="學年度" class="text-center">{{item.schYearTerm}}</td>
                      <td data-title="系別班級" class="text-center">{{item.deptName}}{{item.dradeClass}}</td>
                      <td data-title="學號" class="text-center">{{item.studentId}}</td>
                      <td data-title="姓名" class="text-center">
                        <router-link :to="'/tenancy-register/edit/' + item.schYearTerm.replace('/', '|') + '/' + item.studentId">{{item.studentName}}</router-link>
                      </td>
                      <td data-title="聯絡電話" class="text-center">{{item.phone}}</td>
                      <td data-title="戶籍地址" class="text-center">{{item.resiCityName}}</td>
                      <td data-title="是否校安賃居" class="text-center" v-if="item.isTenancy=='未填寫'"><img src="/assets/images/star.png"></td>
                      <td data-title="是否校安賃居" class="text-center" v-else>{{item.isTenancy}}</td>
                      <td data-title="校外賃居地址" class="text-center">{{item.tenancyAddress}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  data() {
    return {
      pageAdmin: false,
      loginInfo: {},
      isTenancy: false,
      search: {
        schYearTerm: null,
        deptCode: null,
        dradeClass: null,
        stayType: null,
        keyword: ""
      },
      allDradeClassList: [],
      dradeClassList: [],
      opening: {
        startDate: null,
        endDate: null
      },
      list: [],
      schYearTermList: [],
      deptList: []
    };
  },
  computed: {
    searchSchYearTerm() {
      return this.search.schYearTerm;
    },
    searchDeptCode() {
      return this.search.deptCode;
    }
  },
  async mounted() {
    this.pageAdmin = await this.isAdmin("tenancy");
    let d = this.nowDate();
    let r = await new Promise(resolve => {
      this.$http.get("/api/shared/login-info").then(a => {
        this.loginInfo = a.body;
        this.$http.get("/api/tenancyRegister/opening-date").then(b => {
          if (b.body) {
            this.opening.startDate = b.body.startDate;
            this.opening.endDate = b.body.endDate;
          }
          if (this.loginInfo.accountType == "STU") {
            if (this.opening.startDate == "" || this.opening.endDate == "") {
              alert("功能尚未開放");
              this.$router.go(-1);
              return resolve(false);
            } else {
              let sd = new Date(this.opening.startDate);
              let ed = new Date(this.opening.endDate);
              ed.setDate(ed.getDate() + 1);
              if (d < sd || d > ed) {
                alert("功能尚未開放");
                this.$router.go(-1);
                return resolve(false);
              }
            }
          }
          resolve(true);
        });
      });
    });
    if (!r) return false;
    this.$http.get("/api/shared/check-tenancy-safety").then(a => {
      this.isTenancy = a.body;
    });
    let nowSchYear = d.getFullYear() - 1911;
    for (let i = nowSchYear; i >= 108; i--) {
      if (i == nowSchYear) {
        let month = d.getMonth() + 1;
        if (month < 8) continue;
        else this.schYearTermList.push(i.toString() + "/1");
      } else {
        this.schYearTermList.push(i.toString() + "/2");
        this.schYearTermList.push(i.toString() + "/1");
      }
    }
    this.search.schYearTerm = this.schYearTermList[0].replace("/", "");
    const api = this.isAdmin("military") ? "/api/shared/full-dept-list" : ("/api/shared/full-dept-list-by-tch-stage/" + this.search.schYearTerm);
    this.$http.get(api).then(a => {
      this.deptList = a.body;
    });
    this.$http.get("/api/shared/dradeclass-list").then(a => {
      this.allDradeClassList = a.body;
    });
    this.load();
  },
  methods: {
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table)
          .DataTable()
          .destroy();
      }
      this.$http
        .get("/api/tenancyRegister", {
          params: {
            schYearTerm: this.search.schYearTerm,
            deptCode: this.search.deptCode,
            dradeClass: this.search.dradeClass,
            stayType: this.search.stayType,
            keyword: this.search.keyword.trim()
          }
        })
        .then(a => {
          this.list = a.body;
          this.$nextTick(b => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁"
              },
              columns: [
                { width: "8%" },
                { width: "14%" },
                { width: "9%" },
                { width: "9%" },
                { width: "10%" },
                { width: "10%" },
                { width: "10%" },
                { width: "30%" }
              ]
            });
          });
        });
    },
    setOpeningDate() {
      if (this.opening.startDate == "" || this.opening.endDate == "") {
        alert("『開放時間』 尚未填寫");
        return false;
      }
      this.$http
        .post("/api/tenancyRegister/opening-date", this.opening)
        .then(a => {
          if (a.body.status) {
            alert("儲存成功");
          } else {
            alert(a.body.msg);
          }
        });
    },
    searchSubmit() {
      this.load();
    },
    searchClear() {
      this.search.schYearTerm = this.schYearTermList[0].replace("/", "");
      this.search.deptCode = null;
      this.search.dradeClass = null;
      this.search.stayType = null;
      this.search.keyword = "";
    },
    setDradeClassList() {
      if (this.searchSchYearTerm == null || this.searchDeptCode == null) {
        this.dradeClassList = [];
        this.search.dradeClass = null;
      } else {
        this.dradeClassList = this.allDradeClassList.filter(a => {
          return (
            a.schYearTerm == this.searchSchYearTerm &&
            this.searchDeptCode.endsWith(a.deptCode)
          );
        });
      }
    },
    download() {
      this.$http
        .post(
          "/api/tenancyRegister/export-register?schYearTerm=" +
            this.search.schYearTerm +
            "&deptCode=" + (this.search.deptCode ? this.search.deptCode : "") +
            "&dradeClass=" + (this.search.dradeClass ? this.search.dradeClass : "") +
            "&isTenancy=" + (this.search.isTenancy ? this.search.isTenancy : "") +
            "&keyword=" + this.search.keyword,
          {},
          { responseType: "arraybuffer" }
        )
        .then(res => {
          this.download2File(res);
        });
    }
  },
  watch: {
    searchSchYearTerm() {
      const api = this.isAdmin("military")
        ? "/api/shared/full-dept-list"
        : "/api/shared/full-dept-list-by-tch-stage/" + this.search.schYearTerm;
      this.$http.get(api).then(a => {
        this.deptList = a.body;
        this.setDradeClassList();
      });
    },
    searchDeptCode() {
      this.setDradeClassList();
    }
  }
};
</script>

<style>
</style>
